// src/modules/wallet/WalletApi.ts
import apiClient from '@skygroup/shared/API/apiClient';
import endpoints from '@skygroup/shared/API/endpoints';
import { Wallet } from "@skygroup/shared/utils/DiamondWalletInterfaces";


export async function fetchDiamondsWallet(modelId?: string | number): Promise<Wallet> {

  
  const res = await apiClient.get(`${endpoints.WALLETS.GET_CASHBACK}/${modelId}`);

  return res.data?.data ?? res.data;
}
